var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 10,
    viewBox: "0 0 6 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.29289 9.70711C4.68342 10.0976 5.31658 10.0976 5.70711 9.70711C6.09763 9.31658 6.09763 8.68342 5.70711 8.29289L4.29289 9.70711ZM1.70711 5.70711L2.41421 5L2.41421 5L1.70711 5.70711ZM1.70711 4.29289L1 3.58579L1 3.58579L1.70711 4.29289ZM5.70711 1.70711C6.09763 1.31658 6.09763 0.683417 5.70711 0.292893C5.31658 -0.0976311 4.68342 -0.0976311 4.29289 0.292893L5.70711 1.70711ZM5.70711 8.29289L2.41421 5L0.999999 6.41421L4.29289 9.70711L5.70711 8.29289ZM2.41421 5L5.70711 1.70711L4.29289 0.292893L1 3.58579L2.41421 5ZM2.41421 5L2.41421 5L1 3.58579C0.218953 4.36683 0.218949 5.63316 1 6.41421L2.41421 5Z",
    fill: "#3D0E6B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrow-left.5fad74c117af437a51cbcd7b2509b0ff.svg";
export { ForwardRef as ReactComponent };